import AccountTreeIcon from "@mui/icons-material/AccountTree";
import TreeList from "./TreeList";
import { EmployeeServicePath, TREE } from "utils/constants";
import permissions from "app/permissions";

//permissions
export const resources = {
  isMenu: true,
  icon: <AccountTreeIcon />,
  name: EmployeeServicePath + TREE,
  title: "Органиграма",
  list: <TreeList name={"default"} />,
  permission: permissions.canPreviewTreeStructure,
};
